import RecipeEditor from "./RecipeEditor";

export default function RecipeCreate() {
  return <RecipeEditor mode="create" />;
}